import React, { useContext, useEffect, useRef, useState } from "react";
import Layout from "../Layout";
import Contact from "../components/Contact";
import { NavLink } from "react-router-dom";
import { LoadContext } from "../App";
import { Helmet } from "react-helmet";

const Services = () => {
  const { load } = useContext(LoadContext);
  const photos = [
    ["Morin-Height", 2],
    ["Tally", 8],
    ["Tally", 11],
    ["Lac", 1],
    ["Vers-Luisant", 1],
    ["Vers-Luisant", 14],
    ["Vers-Luisant", 38],
    ["Vers-Luisant", 41],
  ];
  const [photoMain, setPhotoMain] = useState(0);
  const [photoPrev, setPhotoPrev] = useState(1);
  const photoMainPresent = useRef(true);

  const refMain = useRef();
  const refPrev = useRef();

  useEffect(() => {
    let timeout;
    const interval = setInterval(() => {
      if (photoMainPresent.current) {
        refPrev.current.style.opacity = 1;
        refMain.current.style.transform = "translateX(-120%)";
        refMain.current.style.scale = 0.5;
        refPrev.current.style.transform = "translateX(0%)";
        refMain.current.style.opacity = 0;
        timeout = setTimeout(() => {
          refMain.current.style.transform = "translateX(100%)";
          refMain.current.style.scale = 1;
          setPhotoMain((prev) => {
            if (prev === photos.length - 2) {
              return 0;
            } else {
              return (prev = prev + 2);
            }
          });
        }, 1000);
        photoMainPresent.current = false;
      } else {
        refMain.current.style.opacity = 1;
        refPrev.current.style.transform = "translateX(-120%)";
        refPrev.current.style.scale = 0.5;
        refMain.current.style.transform = "translateX(0%)";
        refPrev.current.style.opacity = 0;
        timeout = setTimeout(() => {
          refPrev.current.style.transform = "translateX(100%)";
          refPrev.current.style.scale = 1;
          setPhotoPrev((prev) => {
            if (prev === photos.length - 1) {
              return 1;
            } else {
              return (prev = prev + 2);
            }
          });
        }, 1000);
        photoMainPresent.current = true;
      }
    }, 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);
  console.log("Page Services");
  console.log(load);

  return (
    <>
      <Helmet>
        <title>Services | Vialle Construction</title>
        <meta
          name="description"
          content="Vialle Construction vous propose des services de construction et de rénovation. Nous vous accompagnons de l’idée à la réalisation de votre projet en vous conseillant, concevant et construisant avec vous"
        />
        <link rel="canonical" href="https://vialleconstruction.ca/Services" />
        <meta property="og:title" content="Services | Vialle Construction" />
        <meta
          property="og:description"
          content="Vialle Construction vous propose des services de construction et de rénovation. Nous vous accompagnons de l’idée à la réalisation de votre projet en vous conseillant, concevant et construisant avec vous"
        />
        <meta
          property="og:url"
          content="https://vialleconstruction.ca/Services"
        />
        <meta
          property="og:image"
          content="https://vialleconstruction.ca/assets/logo.png"
        />
      </Helmet>
      <Layout>
        <div className="servicesPage">
          <img
            src="./assets/miniature/services.webp"
            alt="Fond d'écran"
            style={{ display: "none" }}
          />
          <div className="title">
            <h1>Services</h1>
            <p>Conseiller - Concevoir - Construire</p>
          </div>
          <div className="services-container">
            <div
              className="service"
              style={load ? { display: "flex" } : { display: "none" }}
            >
              <h3>Conception : Le cœur du projet</h3>
              <p>
                Sans volonté, sans envie et sans plan, on ne se lance pas dans
                la construction d'une maison. Pour une maison performante, la
                planification est la clé du succès.<br></br>
                <br></br>Le point de départ du rêve, l'essence même de
                <span> Vialle Construction</span> : conseiller pour mieux
                concevoir. Nous construirons ensemble sur de bonnes bases.
              </p>
            </div>
            <div
              className="service"
              style={load ? { display: "flex" } : { display: "none" }}
            >
              <h3>Construction – Rénovation</h3>
              <p>
                Avec une bonne planification, l'efficacité énergétique devient
                facilement atteignable. Oui, même avec le climat québécois !
                <br></br>
                <br></br>Nous sommes convaincus que les relations pérennes de
                confiance sont primordiales pour créer un projet de haute
                qualité. Notre équipe qualifiée et nos partenaires spécialistes
                mettront leur savoir-faire à votre service.
              </p>
            </div>
            <div className="case-contact">
              <Contact />
            </div>
          </div>
          <div className="nos-realisations">
            <div className="defilement">
              <div className="photoMain" ref={refMain}>
                <img
                  src={`./assets/IMG/${photos[photoMain][0]}/1%20(${photos[photoMain][1]}).webp`}
                  width={400}
                  alt="Photo d'une réalisation"
                />
              </div>
              <div className="photoPrev" ref={refPrev}>
                <img
                  src={`./assets/IMG/${photos[photoPrev][0]}/1%20(${photos[photoPrev][1]}).webp`}
                  width={400}
                  alt="Photo d'une réalisation"
                />
              </div>
            </div>
            <NavLink className="btn-realisations" to={"/Realisations"}>
              Voir nos réalisations
            </NavLink>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Services;
